package presentation.screens

import com.kinoshazam.model.AppUpdate
import com.kinoshazam.model.Features
import com.kinoshazam.update.ProgressEntity
import utils.UiAction
import utils.UiState

data class RootState(
    val local: String?,
    val theme: String?,
    val appUpdate: AppUpdate? = null,
    val features: Features? = null,
    val globalConfig: String = "",
    val deeplink: String? = null,
    val loadProgress: ProgressEntity = ProgressEntity(0, 1)
) : UiState

sealed interface RootMVIAction : UiAction {

    data object UpdateClicked : RootMVIAction
}